import { tracked } from '@glimmer/tracking';
import type { CompanyLpnSettingExtension as CompanyLpnSetting } from 'tio-data/data/resources/company-lpn-setting.ext';
import type { CompanySettingExtension as CompanySetting } from 'tio-data/data/resources/company-setting.ext';
import type { LpnPage } from './lpn-page.type.ts';
export interface LpnPageExtension extends LpnPage {}
export class LpnPageExtension {
  @tracked declare setting?: CompanyLpnSetting;

  @tracked declare isEnabled?: boolean;

  @tracked declare employerRecommended?: boolean;

  @tracked declare hasDiscount?: boolean;

  @tracked declare createdByOtherCompany?: boolean;

  get savingsPercentRange(): string | undefined {
    return this.discountPercentRange;
  }

  set savingsPercentRange(value: string | undefined) {
    this.discountPercentRange = value;
  }

  get savingsAmountRange(): string | undefined {
    return this.saveDollarAmountRange;
  }

  set savingsAmountRange(value: string | undefined) {
    this.saveDollarAmountRange = value;
  }

  /**
   * Find the CompanyLpnSetting for this page and the provided company setting.
   * Returns `undefined` if none exists.
   *
   * Usage:
   *   await lpnPage.settingForCompany(companySetting);      // or
   *   await lpnPage.settingForCompany(companySettingId);
   */
  async settingForCompany(
    companySettingOrId: CompanySetting | string | null | undefined
  ): Promise<CompanyLpnSetting | undefined> {
    if (!companySettingOrId) return undefined;

    const targetId =
      typeof companySettingOrId === 'string' ? companySettingOrId : companySettingOrId.id;

    // Resolve the async hasMany; already-included data will resolve instantly.
    const settings = await this.companyLpnSettings;

    return settings?.find((s) => s.companySetting?.id === targetId);
  }
}

const Registration = {
  kind: 'object',
  name: 'lpn-page',
  features: LpnPageExtension,
};
export default Registration;
